import { render, staticRenderFns } from "./ViewMethodStudySetting.vue?vue&type=template&id=098b8f50&"
import script from "./ViewMethodStudySetting.vue?vue&type=script&lang=js&"
export * from "./ViewMethodStudySetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports